const estudioGrupoInitialState = {
    estudioGrupo: {
      loading: false,
      error: null,
      data: null,
    },
    estudiosMasBuscado: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default estudioGrupoInitialState;